import {Component, OnInit, AfterViewInit, ViewChild, OnDestroy} from '@angular/core';
import { Store } from "@ngrx/store";
import { environment } from '../../../environments/environment';
import { UserPlanService } from "../../service/userplan.service";
import { HttpService } from "../../service/http.service";
import { ActivatedRoute, Router } from "@angular/router";
import { eventEmitterService } from '../../service/eventEmitter.service';

declare var $:any;
import * as AES from 'crypto-js/aes';
import * as Utf8 from 'crypto-js/enc-utf8';
import {UpgradeModalComponent} from "../upgrade-modal/upgrade-modal.component";
import {UserService} from "../../service/user.service";
import {UpgradeService} from "../../service/upgrade.service";
import {PaymentService} from "../../service/payment.service";
import { HttpClient } from '@angular/common/http';
declare var window:any;

//Base64 encode of 'mycoopSocialNetwork'
var secretKey = 'bXljb29wU29jaWFsTmV0d29yaw==';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.css']
})
export class PricingComponent implements OnInit, OnDestroy,AfterViewInit {

  constructor(private store: Store<any>,
              private plan: UserPlanService,
              private _http : HttpClient,
              private http: HttpService,
              private emitter: eventEmitterService,
              private router: Router,
              private userService : UserService,
              private route : ActivatedRoute,
              private upgradeService: UpgradeService,
              private paymentService: PaymentService) { }

  userDataPresent = false;
  userDetails : any;
  user : any = null;
  error;
  newbuilding: boolean = true;
  userBuildingId = localStorage.getItem('userBuildingId');
  isPaidBuilding = false;


  @ViewChild(UpgradeModalComponent, { static: false }) upgradeModal: UpgradeModalComponent;

  ngOnInit() {
    if (this.userBuildingId) {
      this.userService.isManagerExists(this.userBuildingId).subscribe((response: any)=> {
        const buildingManager: any[] = response.building[0] ? response.building[0].buildingManager : [];
        if (buildingManager.length > 0) {
          this.isPaidBuilding = true;
        }
      });
    }
    var encryptedVal = this.route.snapshot.queryParams['select'];
    this.newbuilding = this.route.snapshot.queryParams['newbuilding'] === 'true';
    console.log('New Building flag', this.newbuilding);
    if(encryptedVal) {
      var bytes = AES.decrypt(encryptedVal.toString(), secretKey);
      var decryptInfo = bytes.toString(Utf8);
      if(decryptInfo == "chooseplan"){
         var userData = this.plan.getUserData();
         if(userData){
            this.userDataPresent = true;
            this.userDetails = userData;
            console.log('UserData', this.userDetails);
         }else{
           this.router.navigate(['/']);
         }
      }else{
        this.router.navigate(['building', 'profile']);
      }
    }
    if (localStorage.getItem('userBuildingId')) {
      this.userService.getUserById(localStorage.getItem('residents')).subscribe(data=>{
        this.user = data.user;
      });
    }
  }

  ngAfterViewInit(){
    setTimeout(()=>{
      $(document).ready(function(){
        window.Intercom("boot", {
          app_id: "kgx05kdo",
        });

    });
    },3000);
    $('#upgrade-modal').on('hide.bs.modal', (e) => {
      console.log('Related target', e.relatedTarget);
      console.log('Event', e);
    });
  }

  modalTriggerMethod() {
    $('#loginForm').modal('show');
  }

  ngOnDestroy(){
    if(window.Intercom){
      window.Intercom("hide");
    }
    $('#loginForm').modal('hide');
  }

  standardPlanUpgradePopup() {
    if (this.user && this.user.isPaid) {
      this.upgradeModal.setUser(this.user);
    }
    $('#upgrade-modal').modal({
      keyboard: false
    });
  }

  subscribeResidentCallback($event) {
    // If user logged in
    if(this.user) {
      // If paid plan, and $event is standard
      if (this.user.isPaid && $event === 'standard') {
        // Downgrade
        this.paymentService.accountDowngrade(this.user.id, localStorage.getItem('userBuildingId')).subscribe((data)=>{
          if (data.success) {
            localStorage.setItem('type', 'resident')
            localStorage.setItem('isManager', 'false')
            localStorage.setItem('userBuildingId', data.buildingIds.toString());
            window.location.href = '/upgradesuccess/?type=false';
          }
        });
      }
      if (!this.user.isPaid && $event === 'advanced') {
        // Upgrade
        this.upgradeService.userSetup(this.user.id);
      }
      console.log('Event', $event);
    } else { // If user's logged out
      if ($event === 'standard') {
        if (this.userDataPresent) {
          this.subscribeResidentPlan('resident');
        } else {
          this.subscribePlan('resident');
        }
      }
      if ($event === 'advanced') {
        if (this.userDataPresent) {
          this.subscribeManagerPlan('manager');
        } else {
          this.subscribePlan('manager');
        }
      }
      if (!this.userDataPresent) {
        $('#addSearchModal').modal('show');
      }
    }
  }

  subscribePlan(plan) {
      if (plan == 'resident'){
          this.plan.setUserPlan('resident');
      }else if (plan == 'manager'){
          this.plan.setUserPlan('manager');
      }
  }

  subscribeResidentPlan(plan) {
     if(this.userDataPresent){
          if(this.userDetails){
             this.http.residentSignup(this.userDetails).subscribe(res => {
                //console.log(res);
                if (res.success) {
                  sessionStorage.removeItem('buildingImage');
                  localStorage.removeItem('buildingImage');
                  sessionStorage.removeItem('userImage');
                  localStorage.removeItem('userImage');
                  localStorage.removeItem('facebookImage');

                  this.router.navigate(['thankyou'], {
                      queryParams: {
                        signup: true,
                        name: res.message.name,
                        email: res.message.email
                      }
                    }
                  );
                }

                /**
                 * facebook user automatic login
                 */
                if(res.user && res.user.facebookInfo){
                  window.location.href= environment.apiUrl+'auth/facebook';
                 }
              },
              (error) => {
                //this.error = [error.message];
                //console.log(this.error, error);
              });
          }
     }
  }

  async subscribeManagerPlan(plan){
    console.log('Subscribe manager plan', plan);
    var managerExists = this.plan.getBuildingManagerExists();
    if(managerExists != null){
      this.error = 'This building already has a manager assigned.  Please contact mycoop for further information.';
      $('#addSearchModal').modal('show');
    } else {
      if (this.user) {
        // If user's logged in
        this.upgradeService.userSetup(this.user.id);
      } else {
        // If not logged in
        if (this.userDataPresent) {
          if (this.userDetails) {
            let userData = this.userDetails.userData;
            await this._http.post(environment.apiUrl + 'buildingManager/saveBuildingManagerSession', {data: userData}).subscribe(data => {
              this.router.navigate(['managerprofile', 'managerbuilding'], {
                queryParams: {
                  processing: true
                }
              });
            }, (error) => {
            });
          }
        }
      }
    }
  }

  enterpriseContact() {
    $('#enterprise-contact').modal('show');
  }

  popupClose(){
    $('#addSearchModal').modal('hide');
  }


}
